export default {
  fbLike: "Facebook Likes",
  fbShare: "Facebook Shares",
  instagramFollow: "Instagram Follows",
  instagramVisit: "Instagram Visits",
  youtubeSubscribe: "YouTube Subscribes",
  youtubeWatch: "YouTube Views",
  pinterestFollow: "Pinterest Follows",
  pinterestPin: "Pinterest Pins",
  snapchatFollow: "Snapchat Follows",
  appDownload: "App Downloads",

  // New social platforms
  tiktokFollow: "TikTok Follows",
  tiktokShare: "TikTok Shares",
  xShare: "X Share",
  xFollow: "X Follows",
  linkedinFollow: "LinkedIn Follows",
  linkedinShare: "LinkedIn Shares",
  whatsappShare: "WhatsApp Shares",
  discordJoin: "Discord Joins",
  twitchFollow: "Twitch Follows",
  threadsFollow: "Threads Follows",
};
